<template>
  <div class="cookie-container">
    <div class="cookie-banner">
      <div v-if="!cookiesManagementOpen" class="title">
        {{ $t('cookies.popupTitle') }}
      </div>
      <div v-else class="title">{{ $t('cookies.cookiesManagement') }}</div>
      <div v-if="!cookiesManagementOpen" class="text">
        {{ $t('cookies.popupText') }}
      </div>
      <CookiesManagement v-else @update-cookies-preference="updateCookiesPreference" />
      <RouterLink :to="{ name: 'cookies' }" class="link">{{ $t('cookies.popupLink') }}</RouterLink>
      <div class="buttons-container">
        <button v-if="!cookiesManagementOpen" class="main-button" @click="cookiesManagementOpen = true">
          {{ $t('cookies.manageCookies') }}
        </button>
        <button class="main-button" :cookiesAgreement="cookiesAgreement" @click="refuseAllCookies">
          {{ $t('cookies.refuseAll') }}
        </button>
        <button class="main-button" @click="acceptAllCookies">
          {{ $t('cookies.acceptAll') }}
        </button>
        <button v-if="cookiesManagementOpen" class="main-button" :class="{ disabled: !cookiesUpdated }" @click="saveCookiesPreferences">
          {{ $t('cookies.saveCookiesPreferences') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CookiesManagement from './CookiesManagement.vue';

export default {
  components: { CookiesManagement },

  data() {
    return {
      cookiesManagementOpen: false,
      cookiesAgreement: false,
      cookiesUpdated: false,
    };
  },

  methods: {
    acceptAllCookies() {
      this.$emit('cookieAgreement', true);
    },

    refuseAllCookies() {
      this.$emit('cookieAgreement', false);
    },

    updateCookiesPreference(value) {
      this.cookiesAgreement = value;
      this.cookiesUpdated = true;
    },

    saveCookiesPreferences() {
      this.$emit('cookieAgreement', this.cookiesAgreement);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
@use 'sass:color';
.cookie-container {
  position: fixed;
  background: rgba(#000, 0.7);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cookie-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  width: 90%;
  color: colors.$text-color;
  background: colors.$white-color;
  border-radius: 6px;

  .title {
    margin-bottom: 30px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    user-select: none;
    color: colors.$darkblue-color;
    position: relative;
  }

  .text {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    text-align: center;
    user-select: none;
  }

  button {
    width: 30%;
  }

  .link {
    width: 100%;
    margin: 20px 0;
    text-decoration: underline;
    transition: 0.2s ease;
    cursor: pointer;
    text-align: center;
    color: colors.$accent-color;
    font-weight: 500;

    &:hover {
      color: color.scale(colors.$accent-color, $lightness: -4%);
    }
  }
}

.buttons-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .button,
  button {
    font-size: 12px;
    transition: 0.3s;
    margin-bottom: 10px;
  }
}

@media (min-width: responsive.$layout-breakpoint-medium) {
  .buttons-container {
    flex-direction: row;
    .button,
    button {
      margin-bottom: 0;
    }
  }
}

@media (min-width: responsive.$layout-breakpoint-large) {
  .cookie-banner {
    width: 60%;
    padding: 20px;
  }

  .buttons-container {
    width: 100%;

    .button,
    button {
      font-size: 14px;
    }
  }
}
@media (min-width: responsive.$layout-breakpoint-extralarge) {
  .cookie-banner {
    width: 40%;
  }
}
</style>
